import DynamicOffer from 'application/src/js/trade-items/dynamic-offer.js';

export default class ContractOffer extends DynamicOffer {
  constructor(args) {
    super(args);
  }
}